export enum UrlRoot {
    claims = 'claims',
    esb = 'esb',
    tests = 'tests',
    reporting = 'reporting',
    users = 'users',
    mz = 'mz',
    kmt='kmt'
}
